/** Do not render an old worker response before a fresh access check or after an error. */
export const currentPayrollResult = <
  T extends {
    data: unknown;
    isError: boolean;
    isLoading: boolean;
    isFetchedAfterMount: boolean;
    fetchStatus: "fetching" | "paused" | "idle";
  },
>(
  query: T,
): Omit<T, "data" | "isLoading"> & {
  data: T["data"] | undefined;
  isLoading: boolean;
} => ({
  ...query,
  data: query.isError || !query.isFetchedAfterMount ? undefined : query.data,
  isLoading:
    query.isLoading ||
    (!query.isFetchedAfterMount &&
      !query.isError &&
      query.fetchStatus !== "idle"),
});
